// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gTM8","code":"_6mJo9"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-code-block.scss
// module id = 790
// module chunks = 3 4 5 6 7